<template>
    <div>
        <filters :scope="filtersScope"></filters>
        <ConversionsTabs></ConversionsTabs>
        <StatisticTable
            class="animated fadeIn"
            :headColumns="headColumns"
            :footColumns="footColumns"
            :rows="rows"
            :title="`${$t('pages.conversions')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import { map } from 'lodash'
  import Helper from '../../../api/Helper'
  import StatisticTable from '../../../components/StatisticTable.vue'
  import ConversionsTabs from './ConversionsTabs.vue'
  import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    name: 'Country',
    components: {
      Filters,
      StatisticTable,
      ConversionsTabs
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          byManualFilter: true
        },
        isLoading: false,
        Storage: Storage,
        Helper: Helper,
        headColumns: [
          {label: this.$root.$t('statistic.date'), field: 'date', width: '120px'},
          {label: this.$root.$t('statistic.total'), field: 'total'},
          {label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2},
          {label: this.$root.$t('statistic.accepted'), field: 'accepted'},
          {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
          {label: this.$root.$t('statistic.error'), field: 'error', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
          {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2},
          {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2},
          {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2},
          {label: this.$root.$t('statistic.approve'), field: 'approve', width: '50px'},
          {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'},
          { label: this.$root.$t('statistic.ad_approved'), field: 'ad_approved' },
          { label: this.$root.$t('statistic.ad_pre_approved'), field: 'ad_pre_approved' },
          { label: this.$root.$t('statistic.ad_difference'), field: 'ad_difference' }
        ],
        rows: [],
        rowsReason: [],
        footColumns: {},
        footColumnsReason: {}
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      newCurrencyHistory (currency) {
        return new Promise(function (resolve, reject) {
          let currencyHistory = []
          API.getCurrencyHistory(currency).then(response => {
            if (response.status === 200) {
              currencyHistory = response.body
              resolve(currencyHistory)
            }
          }).catch(error => {
            reject(error)
          })
        })
      },
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.footColumns = {}
        let oldArrCurrency = []
        let newArrCurrency = []
        API.getConversionsCountryStatistic().then(response => {
          map(response.data, d => {
            oldArrCurrency.push(d.local_currency.split(','))
            oldArrCurrency.forEach(array => {
              array.forEach(item => {
                newArrCurrency.push(item)
              })
            })
          })
          let filterCurrency = newArrCurrency.filter((item, index) => {
            return newArrCurrency.indexOf(item) === index
          })
          // Получение местной валюты
          this.newCurrencyHistory(filterCurrency).then(valueCurrency => {
            const localCurrency = (date, currency) => {
              let localValueCurrency = valueCurrency.find(item => {
                if (item.date === date && item.currency === currency) {
                  return item
                }
              })
              if (localValueCurrency) {
                return localValueCurrency.value
              }
            }
            //
            let sumTotal = 0
            let sumProcessed = 0
            let countProcessed = 0
            let sumAccepted = 0
            let countAccepted = 0
            let sumCanceled = 0
            let countCanceled = 0
            let sumError = 0
            let countError = 0
            let sumReturn = 0
            let countReturn = 0
            let sumPaid = 0
            let countPaid = 0
            let sumAverageBillLocal = 0.0
            let sumAverageBuybackLocal = 0.0
            let sumAverageBill = 0.0
            let sumAverageBuyback = 0.0
            let sumAdApproved = 0
            let sumAdPreApproved = 0
            let sumAdDifference = 0
            const count = Object.keys(response.data).length

            // парсим
            map(response.data, (d, index) => {
              const isAverageBillUsd = !!d.average_bill_usd
              const isAverageBillLocal = !!d.average_bill_local
              const isAverageBuyoutUsd = !!d.average_buyout_usd
              const isAverageBuyoutLocal = !!d.average_buyout_local

              this.rows.push({
                date: {
                  value: d.date,
                  colouredDayOff: true
                },
                total: {
                  value: d.total,
                  bg: true
                },
                processed: {
                  value: d.processed,
                  bg: true,
                  bgg: Helper.renderGistPart(d.total, d.processed),
                  isCollspaned: true
                },
                processedPercent: {
                  value: Helper.percents(d.total, d.processed),
                  bgg: Helper.renderGistPart(d.total, d.processed, true)
                },
                accepted: {
                  value: d.approved,
                  bg: true
                },
                canceled: {
                  value: d.canceled,
                  bgg: Helper.renderGistPart(d.total, d.canceled),
                  isCollspaned: true,
                  popup: true,
                  id: index,
                  date: d.date
                },
                canceledPercents: {
                  value: Helper.percents(d.total, d.canceled),
                  bgg: Helper.renderGistPart(d.total, d.canceled, true)
                },
                error: {
                  value: d.error,
                  bgg: Helper.renderGistPart(d.total, d.error),
                  isCollspaned: true
                },
                errorPercents: {
                  value: Helper.percents(d.total, d.error),
                  bgg: Helper.renderGistPart(d.total, d.error, true)
                },
                return: {
                  value: d.return,
                  bgg: Helper.renderGistPart(d.approved, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: Helper.percents(d.approved, d.return),
                  bgg: Helper.renderGistPart(d.approved, d.return, true)
                },
                paid: {
                  value: d.paid,
                  bgg: Helper.renderGistPart(d.approved, d.paid),
                  isCollspaned: true
                },
                paidPercents: {
                  value: Helper.percents(d.approved, d.paid),
                  bgg: Helper.renderGistPart(d.approved, d.paid, true)
                },
                averageBill: {
                  value: '$ ' + d[ isAverageBillUsd ? 'average_bill_usd' : 'average_bill' ].toFixed(2),
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true)),
                  isCollspaned: true
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length !== 2 && localCurrency(d.date, d.local_currency) ? `${Helper.newAverageBillDay(isAverageBillLocal ? d.average_bill_local : d.average_bill, localCurrency(d.date, d.local_currency), getSymbolFromCurrency(d.local_currency))}` : '-'
                },
                averageBuyback: {
                  value: '$ ' + d[ isAverageBuyoutUsd ? 'average_buyout_usd' : 'average_buyout' ].toFixed(2),
                  isCollspaned: true
                },
                averageBuybackLocal: {
                  value: d.local_currency.split(',').length !== 2 && localCurrency(d.date, d.local_currency) ? `${Helper.newAverageBillDay(isAverageBuyoutLocal ? d.average_buyout_local : d.average_buyout, localCurrency(d.date, d.local_currency), getSymbolFromCurrency(d.local_currency))}` : '-'
                },
                approve: {
                  value: Helper.percents(d.total, d.approved),
                  bgg: Helper.renderSingleGist(d.total, d.approved)
                },
                approvedFromValid: {
                  value: `${(d.approved_from_valid).toFixed(1)}%`
                },
                ad_approved: {
                  value: d.ad_approved ? Number(d.ad_approved.toFixed(2)) : 0
                },
                ad_pre_approved: {
                  value: d.ad_pre_approved ? Number(d.ad_pre_approved.toFixed(2)) : 0
                },
                ad_difference: {
                  value: isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : Number((d.ad_approved - d.ad_pre_approved).toFixed(2))
                }
              })
              sumTotal += d.total
              if (d.processed > 0) {
                sumProcessed += d.processed
                countProcessed++
              }
              if (d.approved) {
                sumAccepted += parseInt(d.approved)
                countAccepted++
              }
              if (d.approved > 0) {
                sumAverageBill += parseFloat(d.average_bill) * d.approved
                sumAverageBuyback += parseFloat(d.average_buyout) * d.paid
                sumAverageBillLocal += d.average_bill * localCurrency(d.date, d.local_currency) * d.approved
                sumAverageBuybackLocal += parseFloat(d.average_buyout * localCurrency(d.date, d.local_currency)) * d.paid
                this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
              }
              if (d.canceled > 0) {
                sumCanceled += d.canceled
                countCanceled++
              }
              if (d.error > 0) {
                sumError += d.error
                countError++
              }
              if (d.return > 0) {
                sumReturn += d.return
                countReturn++
              }
              if (d.paid > 0) {
                sumPaid += d.paid
                countPaid++
              }
              if (d.ad_approved > 0) {
                sumAdApproved += parseInt(d.ad_approved)
              }
              if (d.ad_pre_approved > 0) {
                sumAdPreApproved += parseInt(d.ad_pre_approved)
              }

              sumAdDifference += isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : d.ad_approved - d.ad_pre_approved
            })
            this.footColumns = {
              label: {
                value: this.$root.$t('statistic.in_total')
              },
              total: {
                value: `${sumTotal} (${Helper.average(sumTotal, count)})`,
                graph: true
              },
              processed: {
                value: `${sumProcessed} (${Helper.average(sumProcessed, countProcessed)})`,
                graph: true
              },
              processedPercent: {
                value: Helper.percents(sumTotal, sumProcessed)
              },
              accepted: {
                value: `${sumAccepted} (${Helper.average(sumAccepted, countAccepted)})`,
                graph: true
              },
              canceled: {
                value: `${sumCanceled} (${Helper.average(sumCanceled, countCanceled)})`,
                graph: true
              },
              canceledPercents: {
                value: Helper.percents(sumTotal, sumCanceled),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              error: {
                value: `${sumError} (${Helper.average(sumError, countError)})`,
                graph: true
              },
              errorPercents: {
                value: Helper.percents(sumTotal, sumError),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              return: {
                value: `${sumReturn} (${Helper.average(sumReturn, countReturn)})`,
                graph: true
              },
              returnPercents: {
                value: Helper.percents(sumAccepted, sumReturn),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              paid: {
                value: `${sumPaid} (${Helper.average(sumPaid, countPaid)})`,
                graph: true
              },
              paidPercents: {
                value: Helper.percents(sumAccepted, sumPaid),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              averageBill: {
                value: Helper.averageBillDayCount(sumAverageBill, sumAccepted),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '$'
                }
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? `${Helper.newLocalAverageBill(sumAverageBillLocal, sumAccepted, this.localCurrencySymbol)}` : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: this.localCurrencySymbol
                } : false
              },
              averageBuyback: {
                value: Helper.averageBillDayCount(sumAverageBuyback, sumPaid),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '$'
                }
              },
              averageBuybackLocal: {
                value: filterCurrency.length === 1 ? `${Helper.newLocalAverageBill(sumAverageBuybackLocal, sumPaid, this.localCurrencySymbol)}` : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: this.localCurrencySymbol
                } : false
              },
              approve: {
                value: Helper.percents(sumTotal, sumAccepted),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              approvedFromValid: {
                value: Helper.approvedFromValid(sumAccepted, sumTotal, sumError)
              },
              ad_approved: {
                value: sumAdApproved
              },
              ad_pre_approved: {
                value: sumAdPreApproved
              },
              ad_difference: {
                value: sumAdDifference
              }
            }
          })
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Country.vue?7e20d7b0